import { EventQuery } from "~graphql/sdk";
import useGetTickets from "../hooks/useGetTickets";
import { PrimaryButton, Text } from "flicket-ui";
import { useRouter } from "next/router";

export default function MainCTA(props: {
  event: EventQuery["event"];
  releaseIsActive: boolean;
}) {
  const router = useRouter();
  const { event, releaseIsActive } = props;
  const { id: eventId, isWaitlistAvailable } = event;
  const { navigate, url } = useGetTickets(eventId);
  const isUnlistedRelease = router.query.slug ? true : false;

  const showGetTicketsCTA = releaseIsActive ?? event?.hasPublicRelease;
  const showPresaleRegistrationCTA =
    !showGetTicketsCTA && !isUnlistedRelease && isWaitlistAvailable;

  if (showGetTicketsCTA) {
    return (
      <PrimaryButton width="100%" to={url} onClick={navigate}>
        <Text fontSize={3}>Get tickets</Text>
      </PrimaryButton>
    );
  }

  if (showPresaleRegistrationCTA) {
    return (
      <PrimaryButton width="100%" to={`/events/${eventId}/waitlist`}>
        <Text fontSize={3}>Register</Text>
      </PrimaryButton>
    );
  }

  return null;
}
